<template>    
    <basic-header
        pretitle="Aqfer Marketing Data Platform"
        title="Sandbox"
        buttonText="Create Sandbox"
        :buttonRoles="buttonRoles"
        @btnClick="showModal({ component: 'addSandbox' })"
    />

    <div class="container-fluid">
        <div class="card">
            <datatable
                tableId="managementList"
                :columns="columns"
                uniqueField="name"
                :data="devAndProdV2Sanboxes"
                :deletable="$store.getters.userRoles.isAqferAdmin"
                @deleteRows="showDeleteSandboxes"
                :compact="true"
                :selectCheckboxes="$store.getters.userRoles.isAqferAdmin"
                :detailColumn="{baseUrl:'', name:'SandboxDetail', identifier:'name'}"
            />
        </div>
    </div>
</template>
<script>
import BasicHeader from "../../components/BasicHeader.vue";
import Datatable from "../../components/Datatable.vue";
import { mapActions } from "vuex";

export default {
    components: { BasicHeader, Datatable },
    data() {
        return {            
            columns: [
                { data: "name",
                  title: "Sandbox Name"
                 },
                { data: "env", 
                  title: "Env"
                },{
                    data: "cluster_name",
                    title: "cluster_name"
                },{
                    data: "k8s_namespace",
                    title: "K8s Namespace"
                }               
            ],
            buttonRoles: [1, 1.5], // aqfer_manager can create only dev sandbox, however it will throw 403 forbidden error if tried to create a prod/prodv2 sandbox
        };
    },   
    computed: {
        devAndProdV2Sanboxes() {
            const dev = this.$store.state.sandbox.devSandboxes || [];
            const prodV2 = this.$store.state.sandbox.prodV2Sandboxes || [];
            return [...prodV2, ...dev];
        }
    },
    beforeMount() {
        this.fetchSandboxes();
    },
    methods: {
        showDeleteSandboxes(rows) {            
            this.showModal({ component: "deleteSandboxes", data: rows });
        },
        ...mapActions({
            showModal: "showModal",
        }),
        fetchSandboxes() {
            this.$store.dispatch("sandbox/fetchSandboxes");
        }
    }   

}
</script>